export const createScene = () => {
    const ascene = document.querySelector("a-scene");
    ascene.object3D.matrixAutoUpdate = false;
    ascene.object3D.matrixWorldAutoUpdate = true;
    ascene.renderer.debug.checkShaderErrors = false;
    ascene.renderer.toneMapping = THREE.ACESFilmicToneMapping;
    ascene.renderer.toneMappingExposure = 1;
    ascene.renderer.xr.cameraAutoUpdate = true;
    THREE.ShaderChunk.tonemapping_pars_fragment =
        THREE.ShaderChunk.tonemapping_pars_fragment.replace(
            "vec3 CustomToneMapping( vec3 color ) { return color; }",
            "#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\n\t\t\tfloat toneMappingWhitePoint = 1.0;\n\t\t\tvec3 CustomToneMapping( vec3 color ) {\n\t\t\t\tcolor *= toneMappingExposure;\n\t\t\t\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n\t\t\t}"
        );
    ascene.renderer.shadowMap.autoUpdate = false;
    ascene.renderer.shadowMap.enabled = false;

    return ascene;
};

export const renderEntities = (entities, ascene) => {
    if (entities && entities[0] && entities[0].id) {
        const sortedEntities = [];

        for (const entity of entities) {
            const classList = entity.classList;
            if (Object.values(classList).includes("initialphysics")) {
                sortedEntities.push(entity);
            }
        }

        for (const entity of entities) {
            const classList = entity.classList;
            if (!Object.values(classList).includes("initialphysics")) {
                sortedEntities.push(entity);
            }
        }

        for (const entity of sortedEntities) {
            const newEntity = document.createElement("a-entity");
            newEntity.id = entity.id || (0, c.Z)();

            for (const attribute in entity.attr) {
                newEntity.setAttribute(
                    entity.attr[attribute].attrName,
                    JSON.parse(JSON.stringify(entity.attr[attribute].attrValue))
                );
            }

            const classList = entity.classList;

            for (const key in classList) {
                newEntity.classList.add(classList[key]);
            }

            newEntity.setAttribute("velocity", "0 0 0");
            ascene.appendChild(newEntity);
        }
    } else if (entities) {
        for (const entity of entities) {
            const newEntity = document.createElement("a-entity");

            for (const property in entity) {
                newEntity.setAttribute(
                    entity[property].attrName,
                    JSON.parse(JSON.stringify(entity[property].attrValue))
                );
                newEntity.id = entity[property].id;

                const classList = entity[property].classList;
                for (const className in classList) {
                    newEntity.classList.add(classList[className]);
                }
                newEntity.setAttribute("velocity", "0 0 0");
            }
            ascene.appendChild(newEntity);
        }
    }
};
